import type { SVGProps } from "react";

const SvgFioLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#00408A" d="M0 .654h24v24H0z" />
    <path
      d="m6.634 10.888.021 3.544L1.51 12.66l5.124-1.772ZM17.301 18.114l-5.678-1.964 4.528-1.559v-3.885L11.644 9.16l5.657-1.964v10.919Z"
      fill="#00408A"
    />
    <path
      d="m11.421 16.257 6.009-2.05L22 12.704l-4.57-1.484-5.998-2.092-6.03-2.07v4.162l.011 2.989v4.14l6.008-2.091Z"
      fill="#00408A"
    />
    <path d="m6.634 10.888.021 3.544L1.51 12.66l5.124-1.772Z" fill="#00408A" />
    <path
      d="M6.476 11.123c0 .374.01 2.7.01 3.085-.362-.129-3.76-1.303-4.474-1.548.714-.245 4.101-1.409 4.464-1.537ZM1 12.66l5.817 2.006-.022-4.002L1 12.66ZM17.301 18.114l-5.678-1.964 4.528-1.559v-3.885L11.644 9.16l5.657-1.964v10.919Z"
      fill="#00408A"
    />
    <path
      d="M17.13 7.419v10.46c-.373-.128-4.272-1.484-5.007-1.73.735-.256 4.186-1.44 4.186-1.44v-4.12s-3.43-1.185-4.165-1.43c.735-.257 4.613-1.601 4.985-1.74Zm-5.998 1.74s4.634 1.59 4.847 1.665v3.65c-.213.075-4.858 1.676-4.858 1.676l6.339 2.198V6.96l-6.328 2.199Z"
      fill="#00408A"
    />
    <path
      d="M22.038 12.584 17.471 11.1h-.002l-5.996-2.092-6.03-2.07-.166-.057v4.337l.011 2.989V18.525l.166-.058 6.008-2.092 6.007-2.049h.001l4.569-1.505.363-.12-.364-.117Z"
      fill="#00408A"
      stroke="#fff"
      strokeWidth={0.25}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.64 9.159 4.507 1.547v3.885L11.62 16.15l5.667 1.964V7.194L11.64 9.16Zm-10.13 3.5 5.145 1.772-.01-3.543-5.135 1.771Zm12.549-1.27h.032c.437-.064.522.78.522 1.057 0 .416-.043.993-.49 1.131 0 0-.01 0-.032.011-.511.107-.511-.928-.511-1.238 0-.395.085-.854.479-.96Zm.021 2.306c.043-.01.075-.01.107-.032.522-.214.895-.822.905-1.42v-.096c0-.16-.032-.299-.085-.437-.149-.385-.554-.523-.927-.449-.042.011-.085.032-.138.043-.448.181-.757.662-.831 1.163-.064.374-.032.897.309 1.142.202.14.437.14.66.086Zm-2.28.822c.118-.011.299-.14.373-.214.118-.139.256-.405.33-.715-.148-.043.043.01-.117-.032a1.34 1.34 0 0 1-.138.32c-.032.043-.106.16-.15.171l-.063.01c-.043-.01-.043-.266-.032-.34v-1.965c-.415.182-.49.203-.927.406.021.096.01.107.01.085 0 .022.011.043.022.086l.075-.011c.064-.01.149-.032.16-.032.085-.01.085.107.085.267v1.42c0 .17-.032.469.106.512.01 0 .128.053.267.032Zm-.703-2.274c-.01-.01-.02-.074 0 0Zm.714-.854c.213 0 .373-.181.373-.405 0-.214-.16-.406-.373-.406-.223 0-.383.182-.383.406 0 .213.16.405.383.405Zm-4.08-.544c.181-.032.298-.032.384 0 .042.01.117.096.117.17 0 .043.032.172.032.278v3.448c0 .096.064.576-.512.918v.213l1.8-.587v-.267c-.287 0-.447-.128-.447-.299V12.8c.192-.043.31-.075.416-.075.085 0 .192.042.256.096a.33.33 0 0 1 .117.17c.01.043.064.171.074.267l.064.3h.128v-2.082h-.181c-.01.15-.032.299-.032.32-.01.107-.075.235-.107.31a.58.58 0 0 1-.234.245c-.181.096-.34.128-.522.181v-1.718c0-.181 0-.31.181-.416l.064-.032c.298-.182.629-.075.788.01.181.075.341.47.405.78l.032.128h.139V9.618L7.72 10.653v.192h.011Z"
      fill="#fff"
    />
  </svg>
);
export default SvgFioLogo;
